var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee-container",class:`marquee-container_theme-${_vm.theme}`},[_c('div',{staticClass:"marquee-content"},_vm._l((_vm.doubledContent),function(item,index){return _c('span',{key:index,staticClass:"marquee-text"},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }